import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as variableOverrides from '../../../variable-overrides'

import type { Feature } from '../feature'

/**
 * Removes temporary scenario variable focus when the draft flow is closed.
 */
export const clearFocusedVariablesOnEditClose = store.effects.create(
  (
    feature: Feature,
    variableOverridesFeature: variableOverrides.Feature,
  ) =>
    rxjs
      .merge(
        feature.actions.cancelEdit.observe(),
        feature.actions.submitEdit.success.observe(),
        feature.actions.submitEdit.cancellation.observe(),
      )
      .pipe(
        rxjs.map(action =>
          variableOverridesFeature.actions.removeFocused
            .from(action)
            .create(),
        ),
      ),
)
